import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from "react";
import { observer } from "mobx-react";
import { ApiContentWrap, BackgroundStub, NextSectionButtonWrap, BackgroundStubFix, CssFixes, ToggleRightPanelButton, ControlsWrap, ChangeViewButton, LayoutVariant } from "@redocly/reference-docs";
import styled from "../../styled-components";
export var ContentWrapper = styled.section(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  max-width: ", ";\n  width: 90%;\n  margin: 0 auto;\n\n  padding: ", ";\n\n  & > article:first-child > h1:first-child {\n    // disable margin top for h1 on the title heading if there is no \"Last updated at\" block\n    margin-top: 0;\n  }\n\n  @media only screen and (min-width: ", ") {\n    width: ", ";\n  }\n"])), function (_ref) {
  var a = _ref.theme;
  return a.components.contentWrapper.maxWidth;
}, function (_ref2) {
  var a = _ref2.theme;
  return a.components.contentWrapper.paddingVertical + " " + a.components.contentWrapper.paddingHorizontal;
}, function (_ref3) {
  var a = _ref3.theme;
  return a.breakpoints.medium;
}, function (_ref4) {
  var a = _ref4.withToc,
      b = _ref4.theme;
  return a ? "calc(90% - " + b.tocPanel.width + ")" : "90%";
});
export var NavButtonsWrapper = styled(ContentWrapper)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: flex-end;\n\n  @media only screen and (min-width: ", ") {\n    flex-direction: row;\n  }\n"])), function (_ref5) {
  var a = _ref5.theme;
  return a.breakpoints.small;
});
export function NextPageWrapperWithRightPanel(a) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApiContentWrap, null, a.withRightPanel && /*#__PURE__*/React.createElement(BackgroundStub, null) || null, /*#__PURE__*/React.createElement(NextSectionButtonWrap, null, a.children)), a.withRightPanel && /*#__PURE__*/React.createElement(BackgroundStubFix, null) || null, /*#__PURE__*/React.createElement(FakeControlsWrap, null));
}
export var ApiReferenceLayout = observer(function (a) {
  var b = a.store;
  return React.useLayoutEffect(function () {
    b.onDidMount();
  }, []), /*#__PURE__*/React.createElement(ApiReferenceLayoutWrap, null, /*#__PURE__*/React.createElement(ApiContentWrap, {
    layout: b.layout === LayoutVariant.THREE_PANEL && b.showRightPanel ? LayoutVariant.THREE_PANEL : LayoutVariant.STACKED
  }, b.options.theme.layout.showDarkRightPanel && b.showRightPanel && b.layout !== LayoutVariant.STACKED && /*#__PURE__*/React.createElement(BackgroundStub, null), a.children), b.options.theme.layout.showDarkRightPanel && b.showRightPanel && b.layout !== LayoutVariant.STACKED && /*#__PURE__*/React.createElement(BackgroundStubFix, null), /*#__PURE__*/React.createElement(ControlsWrap, null, /*#__PURE__*/React.createElement(ToggleRightPanelButton, {
    store: b,
    isVisible: b.layout === LayoutVariant.THREE_PANEL
  }), /*#__PURE__*/React.createElement(ChangeViewButton, {
    store: b,
    isVisible: b.showRightPanel
  })), /*#__PURE__*/React.createElement(CssFixes, {
    whiteLabel: b.options.whiteLabel,
    showRightPanel: b.showRightPanel,
    layout: b.layout
  }));
});
var ApiReferenceLayoutWrap = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  > * {\n    padding: ", ";\n  }\n\n  > ", " {\n    padding: 0;\n  }\n"])), function (_ref6) {
  var a = _ref6.theme;
  return a.components.contentWrapper.paddingVertical + " " + a.components.contentWrapper.paddingHorizontal;
}, ControlsWrap);
export var FakeControlsWrap = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 36px;\n  height: 0px;\n"])));